import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { projectGroupsApi } from "@/features/enterprises/api/projectGroups";
import type { ProjectGroupFormData } from "@/features/enterprises/types";

export const projectGroupKeys = {
  all: ["project-groups"] as const,
  list: () => [...projectGroupKeys.all, "list"] as const,
};

export function useProjectGroups() {
  return useQuery({
    queryKey: projectGroupKeys.list(),
    queryFn: () => projectGroupsApi.list(),
  });
}

export function useCreateProjectGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: ProjectGroupFormData) => projectGroupsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: projectGroupKeys.all }),
  });
}

export function useUpdateProjectGroup(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<ProjectGroupFormData>) => projectGroupsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: projectGroupKeys.all }),
  });
}

export function useDeleteProjectGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => projectGroupsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: projectGroupKeys.all }),
  });
}
